import { CSSProperties, ReactNode } from 'react';
import * as S from './styles';
import { DataListProps } from '@/components/atoms/DataList';

export type DataListItemProps = DataListProps & {
  $orientation: 'horizontal' | 'vertical';
  $label: string;
  $highContrast: boolean;
  $conteudo: ReactNode;
  style?: CSSProperties;
};

export default function DataListItem(props: DataListItemProps) {
  const { $label, $conteudo } = props;
  return (
    <S.Container {...props}>
      <S.Label {...props}>{$label}</S.Label>
      {$conteudo}
    </S.Container>
  );
}
